import type VueRouter from 'vue-router';
import TrackingData from '@/shared/reportDataTracking';

/** stay time on page */
const durationTimeMap = {} as any;
/**
 * leave page
 */
export function trackPageEndGuard(router: VueRouter) {
  router.beforeEach((to, from, next) => {
    if (durationTimeMap[from.path] && !from.meta?.excludeTracking && from.meta?.trackingPgName) {
      TrackingData.trackPageEnd({
        eventIntervalSpan: Date.now() - durationTimeMap[from.path],
        timeZone: new Date().getTime(),
      });
    }
    next();
  });
}
export function trackPageEnterGuard(router: VueRouter) {
  /**
   * enter page
   */
  router.afterEach((to) => {
    if (!to.meta?.excludeTracking && to.meta?.trackingPgName) {
      durationTimeMap[to.path] = Date.now();
      TrackingData.trackPageEnter({
        timeZone: new Date().getTime(),
      });
    }
  });
}
